import { API } from 'data';
import { RestAPI } from 'scripts';
import { LocationType, PaginationType, PostType } from 'types';

export const __HOME_POSTS_PAGE_SIZE = 36;

export const __HomePageQueryKey = (postsQueryKey: readonly unknown[]) => [...postsQueryKey, 'page'] as const;

export function __HomeLoadedPage(cached?: PaginationType<PostType<'list'>>): number {
    if (!cached?.data.length) return 1;
    return Math.min(cached.num_of_pages, Math.max(1, Math.ceil(cached.data.length / __HOME_POSTS_PAGE_SIZE)));
}

export type __HomePostsFetchParams = {
    page: number;
    locations?: LocationType<'list'>[];
};

export function __FetchHomePosts(
    params: __HomePostsFetchParams,
    prev?: PaginationType<PostType<'list'>>,
): Promise<PaginationType<PostType<'list'>>> {
    const requestParams: { [key: string]: number | string | number[] } = {
        page: params.page,
        page_size: __HOME_POSTS_PAGE_SIZE,
        ordering: '-renewed_at',
    };
    if (params.locations?.length) requestParams.location_descendants__in = params.locations.map((i) => i.id);
    return RestAPI.get<PaginationType<PostType<'list'>>>(API.posts.list, requestParams).then((res) => {
        if (params.page === 1) return res.data;
        return { ...res.data, data: [...(prev?.data ?? []), ...res.data.data] };
    });
}
